import React from 'react';
import './BbNavigation.css';

class Navigation extends React.Component {
  render()
  {
    return (
      <div className="bb-nav">
        <span className="bb-nav">
          <img
            className="bb_logo"
            src="/wp-content/uploads/2021/03/BB120xRound.png"
            alt="Brain Bout"
          />
        </span>
        <span className="bb-nav">
          <a id="bb-my-stuff-link" href="/my-stuff/">
            My Stuff
          </a>
        </span>
        <span className="bb-nav">
          <a
            id="bb-my-stuff-link"
            href="/my-stuff/#bbprivrm"
          >
            Get a Private Room
          </a>
        </span>
        <span>
          {this.props.playerName}
        </span>

      </div>
    );
  }
}

export default Navigation;
